import { NavLink } from "react-router-dom";
import React from "react";

const MainNav = () => (
  <div className="nav-section">
    <NavLink to="/" className="nav-link">
      <span>Home</span>
    </NavLink>
    <NavLink to="/tool" className="nav-link">
    <span>Record Operatorio</span>
    </NavLink>
    <NavLink to="/pure" className="nav-link">
    <span>Registro Médico</span>
    </NavLink>
    <NavLink to="/realtime" className="nav-link">
    <span>MDT</span>
    </NavLink>
    <NavLink to="/beta" className="nav-link">
    <span>MDT(BETA)</span>
    </NavLink>
    <NavLink to="/webmdn" className="nav-link">
    <span>QuickNotes</span>
    </NavLink>
    <NavLink to="/profile" className="nav-link">
    <span>Profile</span>
    </NavLink>
  </div>
);

export default MainNav;
